if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.form.querySelector("[name=id]").disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart =
					document.querySelector("cart-notification") ||
					document.querySelector("cart-drawer");
				this.submitButton = this.querySelector('[type="submit"]');
				if (document.querySelector("cart-drawer"))
					this.submitButton.setAttribute("aria-haspopup", "dialog");
			}

			onSubmitHandler(evt) {
				evt.preventDefault();
				if (this.submitButton.getAttribute("aria-disabled") === "true") return;

				this.handleErrorMessage();

				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				this.querySelector(".loading-overlay__spinner").classList.remove(
					"hidden"
				);

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (this.cart) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							this.handleErrorMessage(response.description);

							const soldOutMessage =
								this.submitButton.querySelector(".sold-out-message");
							if (!soldOutMessage) return;
							this.submitButton.setAttribute("aria-disabled", true);
							this.submitButton.querySelector("span").classList.add("hidden");
							soldOutMessage.classList.remove("hidden");
							this.error = true;
							return;
						} else if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						this.error = false;
						const quickAddModal = this.closest("quick-add-modal");
						if (quickAddModal) {
							document.body.addEventListener(
								"modalClosed",
								() => {
									setTimeout(() => {
										this.cart.renderContents(response);
									});
								},
								{ once: true }
							);
							quickAddModal.hide(true);
						} else {
							this.cart.renderContents(response);
						}
					})
					.catch((e) => {
						console.error(e);
					})
					.finally(() => {
						this.submitButton.classList.remove("loading");
						if (this.cart && this.cart.classList.contains("is-empty"))
							this.cart.classList.remove("is-empty");
						if (!this.error) this.submitButton.removeAttribute("aria-disabled");
						this.querySelector(".loading-overlay__spinner").classList.add(
							"hidden"
						);
					});
			}

			handleErrorMessage(errorMessage = false) {
				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}

$("#add-to-cart-btn").on("click", (e) => {
	// if use klaviyo ajax cart
	const preorderItem = document.querySelector(".product_buy_preorder");
	const checkUseKlaviyo = document.querySelector("#kss");
	const add_text = "ADD TO CART";
	const preorder_text = "PREORDER";
	if (checkUseKlaviyo !== null) {
		e.preventDefault();
		$.ajax({
			type: "POST",
			url: window.Shopify.routes.root + "cart/add.js",
			dataType: "json",
			data: $(".add_to_cart").serialize(),
			success: function () {
				disableAddToCart(
					"PRODUCT ADDED TO CART",
					preorderItem ? preorder_text : add_text
				);
				updateCart();
			},
			error: function (e) {
				const { description } = e.responseJSON;
				disableAddToCart(description, add_text);
			},
		});
	}
});

function disableAddToCart(message, timeoutMessage) {
	$("#add-to-cart-btn")
		.attr("disabled", "disabled")
		.addClass("add-to-cart-btn");

	$('[name="add"] > span').text(message);
	setTimeout(() => {
		$("#add-to-cart-btn").removeClass("add-to-cart-btn");
		$('[name="add"] > span').text(timeoutMessage);
		$("#add-to-cart-btn").removeAttr("disabled", "disabled");
	}, 2000);
}

function updateCart() {
	$.ajax({
		type: "GET",
		url: "/cart.js",
		dataType: "json",
		success: function (cart) {
			const { item_count } = cart;
			console.log(item_count);
			$("#cart-count").text(`${item_count}`);
		},
	});
}
